import React, {useState, useEffect} from "react"
import axios from "axios"
import {useHistory, Link} from "react-router-dom"

const MovieList = () =>{
  let history = useHistory()
//   const [
//     movie,
//     setMovie,
//     fetch,
//     setFetch,
//   ] = useContext(MovieContext);
const [games, setGames] = useState([]);
const [fetch, setFetch] = useState(true)
const [search, setSearch] = useState([])

    
useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(
        `https://backendexample.sanbersy.com/api/data-game`
      );

      setGames(
        result.data.map((el) => {
          const {
            id,
            name,
            genre,
            singlePlayer,
            multiplayer,
            platform,
            release,
            image_url,
          } = el;
          return {
            id,
            name,
            genre,
            singlePlayer,
            multiplayer,
            platform,
            release,
            image_url,
          };
        })
      );
    };
    
     if(fetch){
        fetchData();
      setFetch(false)
    }
  }, [fetch]);
  const handleEdit = async (event)=>{
    let editedId = parseInt(event.target.value)
    history.push(`/games/edit/${editedId}`)
  }

  const handleDelete = (event)=>{
    let deletedId = parseInt(event.target.value)
    axios.delete(`https://backendexample.sanbersy.com/api/data-movie/${deletedId}`).then(
      ()=>{
        // trigger fetch data in use effect for set scores
        setFetch(true)
      }
    )
  }

  const createNewData = ()=>{
    history.push('/games/create')
  }

  const submitSearch = (e) =>{
    e.preventDefault()
    axios.get(`https://backendexample.sanbersy.com/api/data-game`)
    .then(res => {
      let resGames = res.data.map(el=>{ return {
          id: el.id, 
          name: el.name, 
          genre: el.genre,
          singlePlayer: el.singlePlayer,
          multiplayer: el.multiplayer,
          platform: el.platform,
          release: el.release,          
          image_url: el.image_url
        }
      })
  
      let filteredGames = resGames.filter(x=> x.name.toLowerCase().indexOf(search.toLowerCase()) !== -1)
      setGames([...filteredGames])
    })
  
  }
  
  const handleChangeSearch = (e)=>{
    setSearch(e.target.value)
  }

  const sp = (singlePlayer) => {
    if(singlePlayer === 1){
      return "Ya"
    }else{
      return "tidak"
    }
  }
  const mp = (multiplayer) =>{
    if(multiplayer === 1){
      return "Ya"
    }else{
      return "tidak"
    }
  }

  

  return (
    <div style={{marginLeft:"150px", paddingRight:"50px"}}>
        <button onClick={createNewData} style={{float:"right", border:"20px", backgroundColor:"#17a2b8", marginRight:"20px", marginTop:"10px", color:"white"}}>+Add</button>
        <br/>
        <br/>
        <h2>Games List</h2>
        <br/>
        <br/>
        <div style={{float:"right", marginBottom:"50px"}}>
      <form onSubmit={submitSearch}>
        <input type="text" value={search} onChange={handleChangeSearch} />
        <button>search</button>
      </form>
        <br/>
        <br/>
    </div>
      <table>
        <thead>
          <tr style={{border:"1px solid", padding:"8px", textAlign:"center", backgroundColor: "#f0f2f5" }}>
            <th>No</th>
            <th>Image</th>
            <th>Nama</th>
            <th>Genre</th>
            <th>Platform</th>
            <th>Single
                Player</th>
            <th>Multi
                Player</th>
            <th>Release</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {
            games.map((el, index)=>{
              return (
                <tr style={{textAlign:"center"}}>
                  <td>{index+1}</td>
                  <td><img src={el.image_url} style={{borderRadius:"10px", height:"210px", width:"150px", objectFit:"cover", paddingTop:"10px"}}/></td>
                  <td>{el.name}</td>
                  <td>{el.genre}</td>
                  <td>{el.platform}</td>
                  <td>{sp(el.singlePlayer)}</td>
                  <td>{mp(el.multiplayer)}</td>
                  <td>{el.release}</td>
                  <td>
                    <button style={{marginRight: "10px"}} onClick={handleEdit} value={el.id}>Edit</button>
                    <button onClick={handleDelete} value={el.id}>Delete</button>
                    <Link to={`/games/detail/${el.id}`}><button>detail</button></Link>
                  </td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
      
    </div>
  )
}
export default MovieList

